var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertPower01 = function SvgAlertPower01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "alert_power-01_svg2__a",
    x1: 22.06,
    x2: 161.4,
    y1: 179.61,
    y2: 55.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#alert_power-01_svg2__a",
    id: "alert_power-01_svg2__b",
    x1: 32.22,
    x2: 171.56,
    y1: 191.02,
    y2: 66.92
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#alert_power-01_svg2__a",
    id: "alert_power-01_svg2__c",
    x1: 32.17,
    x2: 171.51,
    y1: 190.96,
    y2: 66.86
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M126.37 101.73H102.7l8.63-30.45c.38-1.33-.23-2.74-1.45-3.38a2.91 2.91 0 0 0-3.6.73l-38.64 46.93a2.913 2.913 0 0 0 2.24 4.77H95l-10.81 32.69c-.44 1.34.14 2.8 1.38 3.48.44.24.92.35 1.39.35.86 0 1.71-.38 2.28-1.09l39.4-49.29c.7-.87.84-2.07.35-3.08a2.92 2.92 0 0 0-2.63-1.65Zm-31.54 37.7 6.98-21.1c.29-.89.14-1.86-.4-2.62a2.92 2.92 0 0 0-2.36-1.21H76.07l25.87-31.42-5.89 20.77c-.25.88-.07 1.82.48 2.55s1.41 1.16 2.32 1.16h21.47l-25.48 31.87Z",
    style: {
      fill: "url(#alert_power-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.92 35.43c-3.68-6.03-10-9.63-16.9-9.63s-13.22 3.6-16.9 9.63L16.49 144.45c-3.99 6.51-4.14 14.71-.4 21.39 3.62 6.46 10.09 10.31 17.31 10.31h133.2c7.22 0 13.69-3.85 17.31-10.29a21.23 21.23 0 0 0-.39-21.4zM178.82 163c-2.57 4.58-7.14 7.32-12.22 7.32H33.4c-5.08 0-9.65-2.74-12.22-7.33-2.75-4.92-2.65-10.71.28-15.5L88.09 38.47c2.61-4.28 7.07-6.84 11.92-6.84s9.31 2.56 11.92 6.84l66.6 109.02c2.93 4.8 3.04 10.6.28 15.51Z",
    style: {
      fill: "url(#alert_power-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.12 138.75 126.53 26.48c-5.78-9.47-15.7-15.13-26.53-15.13s-20.75 5.66-26.53 15.13L4.88 138.75c-6.28 10.28-6.51 23.2-.61 33.73 5.68 10.13 15.82 16.17 27.14 16.17h137.15c11.33 0 21.49-6.05 27.17-16.18 5.9-10.53 5.67-23.45-.61-33.72m-4.47 30.87c-4.64 8.27-12.9 13.21-22.09 13.21H31.41c-9.18 0-17.42-4.93-22.06-13.2-4.95-8.83-4.77-19.23.5-27.84L78.44 29.51c4.72-7.72 12.78-12.34 21.56-12.34s16.84 4.61 21.56 12.34l68.59 112.27c5.26 8.61 5.44 19.01.5 27.83Z",
    style: {
      fill: "url(#alert_power-01_svg2__c)"
    }
  }));
};
export default SvgAlertPower01;